export default __webpack_public_path__ + "static/media/food2.67b50a1c.jpeg";